var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.558 7.49888C18.8348 7.80706 18.8093 8.28125 18.5011 8.55801L10.4838 15.758C10.1987 16.014 9.76645 16.014 9.48141 15.7579L5.49875 12.1795C5.19063 11.9027 5.16528 11.4285 5.44212 11.1203C5.71896 10.8122 6.19315 10.7869 6.50127 11.0637L9.98279 14.1918L17.4989 7.44199C17.8071 7.16523 18.2813 7.1907 18.558 7.49888Z",
    fill: "#259A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIcon);
export default __webpack_public_path__ + "static/media/selected-icon.a8b71a238cda591505405c0194df7307.svg";
export { ForwardRef as ReactComponent };